import { render, staticRenderFns } from "./ProjectActionsClone.vue?vue&type=template&id=7f97bfcf&lang=pug&"
import script from "./ProjectActionsClone.vue?vue&type=script&lang=js&"
export * from "./ProjectActionsClone.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActionsClone.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports